// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"ecb5237c","334":"5e4cf2b9","740":"54cc030e","854":"6e5f98a9"}[chunkId] + ".chunk.css";
};